<div class="modal-header">
    <h2 class="modal-title fkm-modal-title" id="modal-title">{{ arbetsorder.beteckning }} {{ arbetsorder.namn }} - Visa
        och justera rutt</h2>
</div>

@if (!!destinationData) {
<div class="modal-body">
    <div class="info-container">
        <rask-cards>
            <rask-card [renderRaskheader]="false">
                <ng-container>
                    <div class="row">
                        <div class="col-7">
                            <rask-label size="12" class="float-start">Startpunkt</rask-label>
                            @if (destinationData.startPunkt?.easting) {
                            <rask-span size="12" class="float-start">
                                <i class="start-color fas fa-lg fa-map-marker pe-2" aria-hidden="true"></i>{{
                                destinationData.startPunkt.easting | raskDecimal }}, {{
                                destinationData.startPunkt.northing | raskDecimal }}
                            </rask-span>
                            }
                        </div>
                        <div class="col-5">
                            <rask-selector
                                label="Vägmotstånd"
                                class="w-100"
                                [values]="vagmotstandValues"
                                [(ngModel)]="vagmotstand"
                                (ngModelChange)="checkActiveArbetsorderTransportavstand()"
                                [viewFormatter]="motstandViewFormatter"
                                [formatter]="motstandFormatter">
                            </rask-selector>
                        </div>
                    </div>
                    <div class="row">
                        @if (destinationData.startpunktJusterad) {
                        <rask-button
                            color="tertiary"
                            (click)="resetStartpunkt()"
                            class="reset-startpoint"
                            icon="fal fa-lg fa-undo" negative>
                            Återställ startpunkt
                        </rask-button>
                        }
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <rask-label size="12" class="float-start">Mottagningsplats</rask-label>
                            <rask-span size="12" class="float-start">
                                <i class="end-color fas fa-lg fa-map-marker-alt pe-2" aria-hidden="true"></i>{{
                                destinationData.mottagningsplats }}
                            </rask-span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-5">
                            <rask-input-number #tillaggsavstand id="tillagavtstand" label="AO tillägg (km)" infoText="Gäller för hela arbetsordern"
                                [disabled]="arbetsorder.anvandVerkligaAvlagg"
                                [(ngModel)]="tillaggsavstandStorstaAvlagg"
                                (change)="onTillaggsavstandStorstaAvlaggChange()"></rask-input-number>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <rask-radiobutton-group
                                [(ngModel)]="arbetsorder.anvandVerkligaAvlagg"
                                label="Avstånd till industri beräknas från"
                                infoText="När verkliga avlägg används beräknas avstånd till industri från avlägg i Prolog när dessa finns. Detta går inte att kombinera med viapunkter eller tilläggsavstånd på arbetsordern. Alternativt används startpunkten ovan."
                                [buttons]="[{key:true, value:'Verkliga avlägg'}, {key:false, value:'Startpunkt på AO'}]"
                                (change)="verkligaAvlaggCheckedChanged($event)">
                            </rask-radiobutton-group>
                        </div>
                    </div>
                </ng-container>
            </rask-card>
            <rask-card [renderRaskheader]="false">
                @if (barighetsklasser.length >= 1) {
                <rask-tabs parameterName="section" layout="parent" aid="tabs" [size]="3">
                    @for (bkklass of barighetsklasser; track bkklass; let i = $index) {
                    <rask-tab
                        [label]="getTabLabel(bkklass)"
                        tabId="bk1"
                        icon="fa-solid fa-road"
                        [iconColor]="getIconColor(bkklass)"
                        [routeId]="bkklass"
                        (onTabSelected)="setActiveBkTab(bkklass)">
                        <div class="row tab-padding">
                            @if (activeTransportAvstand.felmeddelande) {
                            <rask-validation-message-row type="error"
                                [message]="activeTransportAvstand.felmeddelande">
                            </rask-validation-message-row>
                            }
                            <rask-label size="12" class="float-start vp-label">
                                Via-punkter
                                <rask-info class="info-vp-padding">Byt ordning på via-punkterna genom att dra och
                                    släppa</rask-info>
                            </rask-label>
                            @if (activeTransportAvstand.viaPunkter.length === 0) {
                            <rask-span size="12" class="float-start">
                                Inga via-punkter är tillagda i kartan
                            </rask-span>
                            }
                            @if (activeTransportAvstand.viaPunkter.length > 0) {
                            <div>
                                <div cdkDropList class="float-start w-100" (cdkDropListDropped)="dropViapunkt($event)"
                                    [cdkDropListData]="activeTransportAvstand.viaPunkter">
                                    @for (viapunkt of activeTransportAvstand.viaPunkter; track viapunkt) {
                                    <div class="dragable-container" cdkDrag>
                                        <i class="viapunkt-color fas fa-lg fa-map-marker-plus pe-2"
                                            aria-hidden="true"></i>Via-punkt {{ viapunkt.index }} {{ viapunkt.easting |
                                        raskDecimal }}, {{ viapunkt.northing | raskDecimal }}
                                        <i class="end-color fal fa-lg fa-trash-alt ps-2" role="button"
                                            (click)="deleteViapunkt(activeTransportAvstand, viapunkt.easting, viapunkt.northing)"
                                            aria-hidden="true"></i>
                                    </div>
                                    }
                                </div>
                            </div>
                            }
                            <div class="row">
                                <div class="col-5">
                                    <rask-label size="12" class="float-start km-style">Sträcka (KM)</rask-label>
                                    <rask-span size="12" class="float-start">
                                        {{ activeTransportAvstand.krontVagvalKm | raskKilometer: 0 }}
                                    </rask-span>
                                </div>
                                <rask-input-number label="Extra km" [(ngModel)]="activeTransportAvstand.extraKm"
                                    class="col-4"
                                    (change)="onExtraKmChange(activeTransportAvstand)"></rask-input-number>
                            </div>
                        </div>
                    </rask-tab>
                    }
                </rask-tabs>
                }
            </rask-card>
        </rask-cards>
    </div>
    <div class="map-container">
        <rask-tpl-transportavstand-karta #map class="popupkarta" [data]="destinationData" (mapReady)="onMapReady()"></rask-tpl-transportavstand-karta>
    </div>
</div>
}

<div class="clearfix"></div>

<ng-container footer>
    <div class="d-flex mb-3">
        <rask-button
            class="ms-auto"
            [disabled]="!canSave()"
            (click)="save()">
            Spara
        </rask-button>
        <rask-button
            color="primary"
            [disabled]="!canCalculate()"
            (click)="beraknaRutt()">
            Visa ny rutt
        </rask-button>
        <rask-button
            color="secondary"
            (click)="tryClose()">
            Stäng
        </rask-button>
    </div>
</ng-container>